import React from 'react';
import { formatSubmissionCode, resolveBrandName } from '../../utils/brandLabel';

interface SubmissionCodeProps {
  submissionId?: string;
  brandName?: string;
  brandId?: string;
  brandLookup?: Map<string, string>;
  mode?: 'bullet' | 'suffix';
  className?: string;
}

export const SubmissionCode: React.FC<SubmissionCodeProps> = ({
  submissionId,
  brandName,
  brandId,
  brandLookup,
  mode = 'bullet',
  className = '',
}) => {
  const label = resolveBrandName({}, brandLookup, brandId, brandName);
  const text = formatSubmissionCode(submissionId, label, mode);
  return <span className={`font-mono font-bold ${className}`}>{text}</span>;
};
